import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import toastReducer from "./slices/toastSlice";
import paginationReducer from "./slices/paginationSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        toast: toastReducer,
        pagination: paginationReducer,
    },
});

export default store;
